import ShuttlesSection from './ShuttlesSection';

export default ShuttlesSection;
